import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import Component from "@glimmer/component";
import { service } from "@ember/service";
import InfoPopup from "glesys-controlpanel/components/info-popup";
import { t } from "ember-intl";
import { arg } from "glesys-controlpanel/utils/arg";
import { bool } from "prop-types";

export default class GatedPrice extends Component {
  @service current;
  @service abilities;

  @arg(bool) showPopup = true;

  get hasResellerPricing() {
    return this.abilities.cannot("access pricing for organization", this.current.organization);
  }

  <template>
    {{#if this.hasResellerPricing}}
      <span class="flex items-center text-black gap-1 min-w-15" data-test-gated-price {{mergeClasses}} ...attributes>
        {{t "label.n/a"}}
        {{#if this.showPopup}}
          <InfoPopup data-test-gated-price-popup>
            {{t "component.conditional-price.text"}}
          </InfoPopup>
        {{/if}}
      </span>
    {{else}}
      {{yield}}
    {{/if}}
  </template>
}
